import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify/lib"; //Check for production css problem
import i18n from "./i18n";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      light: {
        primary: "#c90039",
        secondary: "#b0bec5",
        accent: "#8c9eff",
        error: "#b71c1c",
        red: "#CA1439"
      }
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
});
